import React from 'react';

function validEditorEvent(event) {
  if (event.target.matches('input')) {
    return false;
  }
  return true;
}

export function useKeyboard(options, deps = []) {
  const { onKeyDown = () => undefined, onKeyUp = () => undefined } = options;

  const handleKeyDown = event => {
    if (validEditorEvent(event)) {
      onKeyDown(event);
    }
  };

  const handleKeyUp = event => {
    if (validEditorEvent(event)) {
      onKeyUp(event);
    }
  };

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, deps);
}
